var _rect, _rect2, _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSpendeskDoubleEntry = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "#5D21D2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_316_18",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 120,
    height: 120
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_316_18)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.4982 56.4115C65.0705 55.9548 65.0705 55.2129 65.4982 54.7533L73.4691 46.1802C73.8967 45.7235 74.5891 45.7235 75.0109 46.1802L91.1273 63.498C91.6684 64.1031 92 64.9235 92 65.8253C92 66.7475 91.6596 67.5766 91.104 68.1875L74.5629 85.962C74.3593 86.186 74.08 86.3111 73.7891 86.3111H57.824C57.2247 86.3111 56.7389 85.7875 56.7389 85.1475C56.7389 84.7984 56.8727 84.4929 57.088 84.2748L73.4836 66.6457C73.6931 66.4246 73.8036 66.1278 73.8036 65.8253C73.8036 65.5228 73.6931 65.2231 73.4836 65.002L65.4924 56.4115H65.4982ZM54.5018 65.0108C54.9265 65.4675 54.9265 66.2093 54.5018 66.6689L46.5309 75.242C46.1033 75.6988 45.4109 75.6988 44.9891 75.242L28.8727 57.9242C28.3316 57.3191 28 56.4988 28 55.5969C28 54.6777 28.3433 53.8457 28.896 53.2348L45.4371 35.4544C45.6407 35.2362 45.92 35.1111 46.2109 35.1111H62.1731C62.7753 35.1111 63.264 35.6348 63.264 36.2806C63.264 36.6238 63.1244 36.9293 62.9062 37.1417L46.5105 54.7708C46.3011 54.9977 46.1905 55.2944 46.1905 55.5969C46.1905 55.8995 46.3011 56.1991 46.5105 56.4231L54.4989 65.0108H54.5018Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSpendeskDoubleEntry);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/spendesk-double-entry.23858957d27ba0ded63893668ac3ef7e.svg";